import { UI } from '../constants/action_type';
import { LIST_UI_SWEEP_TYPE } from '../constants/list_ui';
import { confirmCancelPendingIntegration } from '../helpers/integration_draft.js'; // eslint-disable-line import/extensions

const keepIntegrationMode = (jcampIdx = 0) => ({
  type: UI.SWEEP.SET_TYPE,
  payload: LIST_UI_SWEEP_TYPE.INTEGRATION_ADD,
  jcampIdx,
});

const setUiViewerType = (payload) => {
  if (!confirmCancelPendingIntegration()) {
    return keepIntegrationMode();
  }

  return {
    type: UI.VIEWER.SET_TYPE,
    payload,
  };
};

const setUiSweepType = (payload, jcampIdx = 0) => {
  if (
    payload !== LIST_UI_SWEEP_TYPE.INTEGRATION_ADD
    && !confirmCancelPendingIntegration()
  ) {
    return keepIntegrationMode(jcampIdx);
  }

  return {
    type: UI.SWEEP.SET_TYPE,
    payload,
    jcampIdx,
  };
};

const selectUiSweep = (payload) => (
  {
    type: UI.SWEEP.SELECT,
    payload,
  }
);

const scrollUiWheel = (payload) => (
  {
    type: UI.WHEEL.SCROLL,
    payload,
  }
);

const clickUiTarget = (
  payload,
  onPeak,
  voltammetryPeakIdx = 0,
  jcampIdx = 0,
  onPecker = false,
  sourceHint = null,
) => ({
  type: UI.CLICK_TARGET,
  payload,
  onPeak,
  voltammetryPeakIdx,
  jcampIdx,
  onPecker,
  sourceHint,
});

const displaySubViewerAt = (payload) => ({
  type: UI.SUB_VIEWER.DISPLAY_VIEWER_AT,
  payload: payload == null ? { x: null, y: null } : payload,
});

// Seeds the LC-MS UVVIS (graph 0) and TIC (graph 1) panes with the same
// x-domain via the existing lcmsSyncX mirroring in updateZoom
// (reducer_ui.js), so both panes share one source of truth for their
// x-extent instead of each auto-fitting to its own data independently.
//
// keepGraphIndex, because this is not a user zoom: a real SELECT_ZOOMIN moves
// zoom.graphIndex to the pane the user just brushed, and saga_lcms_ui reads
// that back to decide which pane the NEXT brush belongs to. Seeding is a
// background write to slot 0, so letting it move the pointer would re-attribute
// a pending TIC zoom (sweepTypes[1] === ZOOMIN) to the UVVIS pane.
const seedLcmsUnionExtent = (xExtent) => ({
  type: UI.SWEEP.SELECT_ZOOMIN,
  payload: {
    graphIndex: 0,
    zoomValue: { xExtent, yExtent: false },
    lcmsSyncX: 1,
    keepGraphIndex: true,
  },
});

export {
  setUiViewerType,
  setUiSweepType,
  selectUiSweep,
  scrollUiWheel,
  clickUiTarget,
  displaySubViewerAt,
  seedLcmsUnionExtent,
};
